/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 予約変更
 */
export interface GetOrderResponseDataOrderEligibilitiesChange {
  /**
   * 案内要否<br/> 以下のいずれかに該当する場合false、そうでない場合true<br/> 1.操作レベルが1(予約操作不可)<br/> 2.操作レベルが2(旅程操作不可)<br/> 3. DxAPIから運賃によって変更ができない旨のコードが返却された。（009 （FLIGHT CHANGE NOT ALLOWED BY FARE）が返却された場合）
   */
  isEligibleToForward?: boolean;
  /**
   * 利用可否<br/> いずれの利用不可理由にも該当しない場合にtrue
   */
  isEligible?: boolean;
  /**
   * 利用不可理由<br/> awardBooking：特典PNR区分がtrue<br/> notRegisteredEmail：連絡先情報の代表者連絡先情報のメールアドレスが未登録、または連絡先情報の搭乗者(INFは除外)毎の情報のメールアドレスが未登録の旅客が存在する<br/> moreThan2Bounds：DxAPIから3バウンド以上の旅程が存在する旨のコードが返却された。（006 （COMPLEX ITINERARY NOT ALLOWED）が返却された場合）<br/> unflownOtherMerchantNdc：PNRチャネル詳細区分がマーチャントがANA以外のNDC PNR、かつ旅程内の第一便のセグメントに紐づくドキュメント情報のDxAPIから返却されたクーポンステータスが未使用である<br/> checkedIn：ドキュメント種別が航空券かつDxAPIから返却されたクーポンステータスがチェックイン済みのドキュメントが含まれる<br/> mexicoPos：操作オフィスのPOSがメキシコである<br/> cannotRefundByAnaSkyCoin：ドキュメント種別が航空券であるドキュメントの支払方法にANA SKYコインが含まれ、かつANA SKYコインの払戻機能がOFF(設定ファイルに定義)<br/> hasUnknownAirport：ASWDB(マスタ)の空港情報に存在しない空港が、旅程に含まれている<br/> unsupportedPaymentMethod：ドキュメント種別が航空券であるドキュメントの支払方法に、変更不可支払方法(設定ファイルに定義)が含まれている<br/> hasUpgradedSegment：バウンド情報にアップグレードしているかがtrueのセグメントが含まれる<br/> flightReaccommodationIsEligible：PNRに対する次に必要なアクションがイレギュラー振替である<br/> invalidTicketDesignator：不正なTicket Designator<br/> ※以下の条件をすべて満たす場合に、不正なTicket Designatorとする。その際、エラー内容を運用確認ログに書き出す。<br/> 1.PNRチャネル詳細区分がASW作成PNR、またはPNRチャネル区分がNDC PNRであり、DxAPIからTicket Designatorが返却される<br/> 2.DxAPIから返却されたTicket Designatorがプロモーションコード(設定ファイルに定義)による割引でないTicket Designatorに該当しない<br/> 3.DxAPIから返却されたTicket Designatorに紐づくプロモーションコードがASWDB(マスタ)のプロモーションコード情報に登録済みでない、または複数件登録済み<br/> memberNotFoundForGmopPayment：ドキュメント種別が航空券であるドキュメントの支払方法にGMOPが含まれかつ、SSR FQTSのフリーテキストにログイン中の会員番号が含まれない<br/> changeableTime：旅程区分が国際旅程、かつ変更可能時間(設定ファイルに定義)未満のセグメントが含まれる<br/> ※変更可能時間については、Dynamic Waiver Change か否かで異なる時間とする<br/> changeableTimeDom：旅程区分が国内旅程、かつバウンドの第一便の出発時間が国内線の変更可能時間(設定ファイルに定義)未満である<br/> ※国内線の変更可能時間については、Dynamic Waiver Change か否かで異なる時間とする<br/> notEligibleByDxApi：全バウンドで以下の条件のいずれかにあてはまる場合<br/> 1.DxAPI から3バウンド以上の旅程が存在する旨のコード（006 （COMPLEX ITINERARY NOT ALLOWED）、運賃によって変更ができない旨のコード（009 （FLIGHT CHANGE NOT ALLOWED BY FARE）以外のコードが返却された<br/> 2.不可理由(nonEligibilityReasons)が回答されていない。<br/> posJapanAndDomesticItinerary：操作オフィスのPOSが日本で、旅程区分がdomestic、かつ出発日が国内DCS移行開始日より前である<br/> allNoShowDom：旅程区分が国内旅程、かつ全セグメントでNO SHOWとなっている場合にallNoShowDomを設定する<br/> mismatchedCompanyIdOrOrganizationId：購入・発券状態が発券済かつPNRの企業ID・組織IDと、旅程変更時にANA Bizにログインしている企業ID・組織IDが一致しない<br/> ※ANA Bizにログインしている企業ID・組織IDはパーソナライズ情報を参照する
   */
  nonEligibilityReasons?: Array<GetOrderResponseDataOrderEligibilitiesChange.NonEligibilityReasonsEnum>;
}
export namespace GetOrderResponseDataOrderEligibilitiesChange {
  export type NonEligibilityReasonsEnum =
    | 'awardBooking'
    | 'notRegisteredEmail'
    | 'moreThan2Bounds'
    | 'unflownOtherMerchantNdc'
    | 'checkedIn'
    | 'mexicoPos'
    | 'cannotRefundByAnaSkyCoin'
    | 'hasUnknownAirport'
    | 'unsupportedPaymentMethod'
    | 'hasUpgradedSegment'
    | 'flightReaccommodationIsEligible'
    | 'invalidTicketDesignator'
    | 'memberNotFoundForGmopPayment'
    | 'changeableTime'
    | 'changeableTimeDom'
    | 'notEligibleByDxApi'
    | 'posJapanAndDomesticItinerary'
    | 'allNoShowDom'
    | 'mismatchedCompanyIdOrOrganizationId';
  export const NonEligibilityReasonsEnum = {
    AwardBooking: 'awardBooking' as NonEligibilityReasonsEnum,
    NotRegisteredEmail: 'notRegisteredEmail' as NonEligibilityReasonsEnum,
    MoreThan2Bounds: 'moreThan2Bounds' as NonEligibilityReasonsEnum,
    UnflownOtherMerchantNdc: 'unflownOtherMerchantNdc' as NonEligibilityReasonsEnum,
    CheckedIn: 'checkedIn' as NonEligibilityReasonsEnum,
    MexicoPos: 'mexicoPos' as NonEligibilityReasonsEnum,
    CannotRefundByAnaSkyCoin: 'cannotRefundByAnaSkyCoin' as NonEligibilityReasonsEnum,
    HasUnknownAirport: 'hasUnknownAirport' as NonEligibilityReasonsEnum,
    UnsupportedPaymentMethod: 'unsupportedPaymentMethod' as NonEligibilityReasonsEnum,
    HasUpgradedSegment: 'hasUpgradedSegment' as NonEligibilityReasonsEnum,
    FlightReaccommodationIsEligible: 'flightReaccommodationIsEligible' as NonEligibilityReasonsEnum,
    InvalidTicketDesignator: 'invalidTicketDesignator' as NonEligibilityReasonsEnum,
    MemberNotFoundForGmopPayment: 'memberNotFoundForGmopPayment' as NonEligibilityReasonsEnum,
    ChangeableTime: 'changeableTime' as NonEligibilityReasonsEnum,
    ChangeableTimeDom: 'changeableTimeDom' as NonEligibilityReasonsEnum,
    NotEligibleByDxApi: 'notEligibleByDxApi' as NonEligibilityReasonsEnum,
    PosJapanAndDomesticItinerary: 'posJapanAndDomesticItinerary' as NonEligibilityReasonsEnum,
    AllNoShowDom: 'allNoShowDom' as NonEligibilityReasonsEnum,
    MismatchedCompanyIdOrOrganizationId: 'mismatchedCompanyIdOrOrganizationId' as NonEligibilityReasonsEnum,
  };
}
